import { render, staticRenderFns } from "./se2a-admin-unit-details.vue?vue&type=template&id=ddf2fe52&scoped=true"
import script from "./se2a-admin-unit-details.vue?vue&type=script&lang=js"
export * from "./se2a-admin-unit-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf2fe52",
  null
  
)

export default component.exports